import { createRoot } from 'react-dom/client'
import './styles/tokens.css'
import './index.scss'
import App from './App.js'
import { FullMaintenanceScreen } from './components/pages/authentication/MaintenanceNotice'
import { initSentry } from './services/sentry'
import { attemptChunkReload } from './utils/chunkReload'
import { shouldShowFullMaintenance } from './utils/maintenanceMode'

// Initialise observability before anything else so early errors are captured.
initSentry();

// Stale dynamic-chunk reload guard. After a Vercel deploy the bundle's
// lazy chunk filenames change (Vite hashes them); a tab that was open
// during the deploy still holds the OLD chunk names in memory. The next
// time the user navigates to a route that triggers a new lazy import,
// Vite tries to fetch <old-hash>.js which now 404s — the route renders
// nothing and the user is stuck on a dead-end "Something went wrong"
// screen (UAT row 23: "white screen still appeared, but when refreshed,
// it loaded"). Reloading fetches index.html again and picks up the new
// chunk hashes.
//
// `vite:preloadError` is dispatched by Vite's own preload helper — which
// wraps every lazy()/dynamic import in the build output — specifically for
// this failure, before the rejection would otherwise propagate. This
// replaces a previous version of this guard that listened for
// `window.onerror` / `unhandledrejection` instead: React.lazy() catches a
// rejected import() promise internally and re-throws it as a render error,
// so it never reaches either of those events — which is why testers kept
// hitting the dead-end screen despite that code already being in place.
// components/common/ErrorBoundary.tsx (the boundary that actually wraps
// every workspace's routed content) has a second, independent detector for
// that render-error path as a backstop.
//
// preventDefault() stops Vite from also re-throwing the original error,
// since we're already handling recovery here. attemptChunkReload() carries
// its own loop guard — see frontend/src/utils/chunkReload.ts.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  attemptChunkReload();
});

const showFullMaintenance = shouldShowFullMaintenance(import.meta.env)

const rootFile: any = document.getElementById('root')
createRoot(rootFile)!.render(
  // <StrictMode>
    showFullMaintenance ? <FullMaintenanceScreen /> : <App />
  // </StrictMode>
  ,
)
